<template>
  <!-- ----------------------------------------------------------------------------- -->
  <!-- DatatablesCRUDActions -->
  <!-- ----------------------------------------------------------------------------- -->
  <div>
    <div class="mt-4">
      <v-data-table :headers="headers" :items="listitems" sort-by="sequence" class="border" hide-default-footer dense>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Student Member Particulars</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="title">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row dense>
                      <v-col cols="12" sm="1" md="1">
                        <v-text-field v-model="editedItem.sequence" label="No." dense></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="11" md="11">
                        <v-text-field v-model="editedItem.course" label="Course of Study" dense></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.instname" label="Name of Institution / Higher Learning Institution" dense></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu ref="datecommenceselector" v-model="datecommenceselector" :close-on-content-click="false" :return-value.sync="datecommenceselector" transition="scale-transition" offset-y min-width="290px">
                           <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="editedItem.datecommence" label="Date Commenced" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense></v-text-field>
                           </template>
                           <v-date-picker v-model="editedItem.datecommence" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="datecommenceselector = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.datecommenceselector.save(editedItem.datecommence)">OK</v-btn>
                           </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu ref="datecompleteselector" v-model="datecompleteselector" :close-on-content-click="false" :return-value.sync="datecompleteselector" transition="scale-transition" offset-y min-width="290px">
                           <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="editedItem.datecomplete" label="Date Completed" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense></v-text-field>
                           </template>
                           <v-date-picker v-model="editedItem.datecomplete" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="datecompleteselector = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.datecompleteselector.save(editedItem.datecomplete)">OK</v-btn>
                           </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-if="editedIndex >= 0" v-model="editedItem.document" label="Uploaded Document" readonly dense></v-text-field>
                        <v-file-input v-model="uploadfile" label="Attach Support Document" append-icon="mdi-clip" accept=".png, .jpg, .jpeg, .pdf, .tiff" show-size dense/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="close">Cancel</v-btn>
                  <v-btn color="primary" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.sequence`]="{ item }">
           <small>{{ item.sequence }}</small>
        </template>
        <template v-slot:[`item.course`]="{ item }">
           <small>{{ item.course }}</small>
        </template>
        <template v-slot:[`item.instname`]="{ item }">
           <small>{{ item.instname }}</small>
        </template>
        <template v-slot:[`item.datecommence`]="{ item }">
           <small>{{ formatDate(item.datecommence) }}</small>
        </template>
        <template v-slot:[`item.datecomplete`]="{ item }">
           <small>{{ formatDate(item.datecomplete) }}</small>
        </template>
        <template v-slot:[`item.document`]="{ item }">
           <small v-if="documentUrl(item)">
              <a :href="documentUrl(item)" target="_blank" rel="noopener">{{ item.document }}</a>
           </small>
           <small v-else class="grey--text">-</small>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
      <v-dialog v-model="dlgconfirm" width="400" persistent dark>
         <v-card>
            <v-card-title class="title"><span class="text-white">Confirm you want to delete this?</span></v-card-title>
            <v-card-text>
               <v-row dense>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>No.</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.sequence }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Course of Study</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.course }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Name of Institution</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.instname }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Date Commenced</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ formatDate(todelete.datecommence) }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Date Completed</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ formatDate(todelete.datecomplete) }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Document</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.document }}</small>
                  </v-col>
               </v-row>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="red darken-1" dark @click="dodelete(todelete)">
                  Yes
               </v-btn>
               <v-btn color="primary" dark @click="dlgconfirm = false">
                  No
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
const axios = require('axios')

export default {
   name: "TableQualStu",

   data: () => ({
      userid: 0,
      focus: false,
      datecommenceselector: false,
      datecompleteselector: false,
      dialog: false,
      headers: [
         {
            text: "No.",
            align: "start",
            sortable: true,
            value: "sequence",
         },
         {
            text: "Course of Study",
            sortable: false,
            value: "course"
         },
         { text: "Name of Institution / Higher Learning Institution", value: "instname", sortable: false },
         { text: "Date Commenced", value: "datecommence", sortable: false },
         { text: "Date Completed", value: "datecomplete", sortable: false },
         { text: "Document", value: "document", sortable: false },
         { text: "Actions", value: "actions", sortable: false }
      ],
      listitems: [],
      submitting: false,
      deleting: false,
      dlgconfirm: false,
      confirmdelete: false,
      uploadfile: null,
      editedIndex: -1,
      editedItem: {
         id: 0,
         sequence: 0,
         course: "",
         instname: "",
         datecommence: "",
         datecomplete: "",
         document: "",
      },
      todelete: {
         id: 0,
         sequence: 0,
         course: "",
         instname: "",
         datecommence: "",
         datecomplete: "",
         document: "",

      },
      defaultItem: {
         id: 0,
         sequence: 0,
         course: "",
         instname: "",
         datecommence: "",
         datecomplete: "",
         document: "",
      }
   }),

   computed: {
      formTitle() {
         return this.editedIndex === -1 ? "Qualification (Student): New Item" : "Qualification (Student): Edit Item"
      }
   },

   watch: {
      dialog(val) {
         val || this.close()
      },
   },

   mounted() {
      this.$emit('QualStuMounted')
   },

   methods: {
      documentUrl(item) {
         if (!item || !item.document || !item.documentpath) {
            return null
         }

         var path = String(item.documentpath).replace(/^\/+|\/+$/g, '')
         var document = String(item.document).replace(/^\/+/g, '')
         return '/' + path + '/' + encodeURIComponent(document).replace(/%2F/g, '/')
      },

      formatDate(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY')
      },

      setuserid(pUserID) {
         this.userid = pUserID
         this.initialize()
      },

      initialize() {
         this.$nextTick(() => {
            var targetPath = ''
            this.uploadfile = null
            if (this.userid !== 0) {
               targetPath = '/member/qualstu/list/' + this.userid // get id from property
            } else {
               targetPath = '/member/qualstu/list' // get id from current login session (server-side)
            }
            axios.get(targetPath)
            .then((resp) => {
               if (resp.data) {
                  var rtn = resp.data
                  if (rtn.status === 'OK') {
                     this.listitems = rtn.data
                  } else {
                     console.log(rtn.status + ': ' + rtn.error)
                  }
               }
            })
         })
      },

      editItem(item) {
         this.editedIndex = this.listitems.indexOf(item)
         this.editedItem = Object.assign({}, item)
         this.dialog = true
      },

      deleteItem(item) {
         this.todelete = item
         this.dlgconfirm = true
      },

      dodelete(item) {
         var targetPath = "/member/qualstu/delete"
         var data = {
            id: item.id
         }
         this.dlgconfirm = false
         this.deleting = true
         axios.post(targetPath, data)
         .then((resp) => {
            this.deleting = false
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.initialize()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      close() {
         this.dialog = false
         setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
         }, 300)
      },

      save() {
         var targetPath = ""
         if (this.editedIndex > -1) {
            targetPath = "/member/qualstu/update"
         } else {
            targetPath = "/member/qualstu/add"
         }
         var data = new FormData()
         if (this.editedIndex > -1) {
            data.append('id', this.editedItem.id)
            data.append('userid', this.userid)
         } else {
            data.append('userid', this.userid)
         }
         data.append('sequence', this.editedItem.sequence)
         data.append('course', this.editedItem.course)
         data.append('instname', this.editedItem.instname)
         data.append('datecommence', this.editedItem.datecommence)
         data.append('datecomplete', this.editedItem.datecomplete)
         if (this.uploadfile) {
            data.append('document', this.uploadfile)
         }

         this.submitting = true
         axios.post(targetPath, data, {
            headers: {
               'Content-Type': 'multipart/form-data'
            }
         })
         .then((resp) => {
            this.submitting = false
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.initialize()
                  this.close()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },
   }
};
</script>
